import { takeEvery, fork, put, all, call } from "redux-saga/effects"
import { SEND_REPORT_OTP, VERIFY_REPORT_OTP } from "./Constants"
import { sendReportOtpApi, verifyReportOtpApi } from "./Api"
import { sendReportOtpFailed, sendReportOtpSuccess, verifyReportOtpFailed, verifyReportOtpSuccess } from "./Actions"

function* sendReportOtpAsync(action) {
    try {
        const response = yield call(sendReportOtpApi, action.payload)
        if (response.status === 200) {
            yield put(sendReportOtpSuccess("Otp Sent Successfully!"))
        } else {
            throw new Error(response)
        }
        // yield put(sendReportOtpSuccess("Otp Sent Successfully!"))
    } catch (error) {
        yield put(sendReportOtpFailed(error.response.data))

    }
}

function* sendReportOtpSaga() {
    yield takeEvery(SEND_REPORT_OTP, sendReportOtpAsync)
}


function* verifyReportOtpAsync(action) {
    try {
         const response = yield call(verifyReportOtpApi, action.payload)
         if (response.status === 200) {
             yield put(verifyReportOtpSuccess("OTP Verified Successfully!"))
         } else {
             throw new Error(response)
         }
       // yield put(verifyReportOtpSuccess("OTP Verified Successfully!"))
    } catch (error) {
        yield put(verifyReportOtpFailed(error.response.data))

    }
}

function* verifyReportOtpSaga() {
    yield takeEvery(VERIFY_REPORT_OTP, verifyReportOtpAsync)
}


function* ReportOtpSaga() {
    yield all([
        fork(sendReportOtpSaga),
        fork(verifyReportOtpSaga),
    ])
}

export default ReportOtpSaga;